<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Teachers List</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="createnew">
                Add Teacher
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn field="phone" header="Phone" />
        <PrimeColumn field="email" header="Email" />
        <PrimeColumn field="gender" header="Gender" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                    <PrimeButton
                        label="Edit"
                        icon="pi pi-user-edit"
                        class="p-button-rounded p-button-text"
                        @click="edit(slotProps.data)"
                    />
                    <PrimeButton
                        label="Subjects"
                        icon="pi pi-bars"
                        class="p-button-rounded p-button-text"
                        @click="subjects(slotProps.data)"
                    />
                    <PrimeButton
                        label="Students"
                        icon="pi pi-users"
                        class="p-button-rounded p-button-text"
                        @click="students(slotProps.data)"
                    />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="2"
            :fields="createFields" @submit="addTeacher"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>

    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        <DynamicForm :columns="2"
            :fields="editFields" @submit="addTeacher"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref} from 'vue';
import { useRouter } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";

export default {
    name:"AcademicYear",
    components:{ModalView,DynamicForm},
    setup(){
        const router = useRouter();
        const state=reactive({loading:true,createModal:false,submitting:false,error:[],success:false,
            gender:[{label:"Male",value:"Male"},{label:"Female",value:"Female"}],editModal:false
        })
        const list = ref([])
        const globalFilter=ref("")
        const editFields=ref([]);
        const createFields=ref([
            { name: "Add Teacher", number: "1",data: 
                [
                    { type: 'text', name: 'name', label: 'Name',
                        value: ""  },
                    { type: 'password', name: 'pass', label: 'Password',
                        value: ""  },
                    { type: 'select', name: 'gender', label: 'Gender',
                        value: "",options:state.gender  },
                    {type: 'date', name: 'dob', label: 'DOB',
                        value: ""},
                    {type: 'text', name: 'email', label: 'Email Address',
                        value: ""},
                    {type: 'text', name: 'phone', label: 'Phone No.',
                        value: ""},
                    {type: 'text', name: 'address', label: 'Address',
                        value: ""},
                    {type: 'text', name: 'religion', label: 'Religion',
                        value: ""},
                    {type: 'date', name: 'join_date', label: 'Join Date',
                        value: ""},
                ]
            }
        ])

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        function addTeacher(data){
            state.submitting=true;
            state.errors=[];
            data.addTeacher="";
            state.success=false;
            call({
                url:urls.teachers,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function edit(row){
            editFields.value.length=0;
            editFields.value.push(
                { name: "Edit Teacher", number: "1",data: 
                    [
                        { type: 'text', name: 'name', label: 'Name',
                            value: row.name  },
                        { type: 'password', name: 'pass', label: 'Password',
                            value: ""  },
                        { type: 'select', name: 'gender', label: 'Gender',
                            value: row.gender,options:state.gender  },
                        {type: 'date', name: 'dob', label: 'DOB',
                            value: row.dob},
                        {type: 'text', name: 'email', label: 'Email Address',
                            value: row.email},
                        {type: 'text', name: 'phone', label: 'Phone No.',
                            value: row.phone},
                        {type: 'text', name: 'address', label: 'Address',
                            value: row.address},
                        {type: 'text', name: 'religion', label: 'Religion',
                            value: row.religion},
                        {type: 'date', name: 'join_date', label: 'Join Date',
                            value: row.join},
                        {type: 'hidden', name: 'id', label: 'Join Date',
                            value: row.id},
                    ]
                }
            );
            state.editModal=true;
        }
        onMounted(() => {
            call({
                url:urls.teachers,
                data:{getTeachersList:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function subjects(row){
            router.push({ name: 'teachersubjects', params: { id: row.id } });
        }

        function students(row){
            router.push({ name: 'teacherstudents', params: { id: row.id } });
        }

        function createnew(){
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
        }
        
        return {list,globalFilter, state,subjects,createFields,addTeacher,createnew,editFields,students,
            edit
        }
    }
}
</script>